// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__3jLUU","title":"Info_title__3T1MG","selects":"Info_selects__up_hE","requiredAsterisk":"Info_requiredAsterisk__2CNOg"};